// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tfsychlartcgbxjzgynf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRmc3ljaGxhcnRjZ2J4anpneW5mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc5MzQ0MzQsImV4cCI6MjA2MzUxMDQzNH0.rWWbRZe3Aj6QSns99zxVAnBWPdNWgDubhZV6avzxuR4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);